import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service'
import { Router, ActivatedRoute} from '@angular/router';
import { Proflie } from '../../../profile';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss']
})
export class UserDashboardComponent implements OnInit {

  isUserLogin: boolean
  users: Object
  total: any
  registerForm: FormGroup
  public errorMsg: any

  constructor(private userApi: ApiService,
    private router:Router,
    private route: ActivatedRoute,
    private fb: FormBuilder) {       
      const newLocal = this.isUserLogin = this.userApi.isLoggedIn();
    }

  ngOnInit(): void {

    this.userApi.getUsers('all').subscribe(
      data => {
        this.users = data;
        // console.log(this.users);
        this.total = Object.keys(data).length;
      },
      error => this.errorMsg = error      
    );

    this.registerForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      email: ['', [Validators.required]],
      active: ['', [Validators.required, Validators.pattern("^[0-1]{1}$")]],
      post_type: ['', [Validators.required]]
    });

  }

  onSelect(website) {
    this.router.navigate([website.url, {type: website.item_category}], {relativeTo: this.route}); // relative url
  }

  onEdit(item: any){
    // console.log(item);
    this.userApi.getUserDetail(item.id)
      .subscribe((data:any) => {
        // console.log(data);
        this.registerForm.patchValue(data);
      });
  }

  editItem(){
    let formValue = this.registerForm.value
    // console.log(formValue)
    this.userApi.updateItem(formValue)
      .subscribe(() => {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/user/dashboard/user']);
      })
  }

  deleteItem(item: Proflie): void{
    this.userApi.deleteItem(item)
      .subscribe(data => {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/user/dashboard/user']);
      })
  }

}
